import Handlebars from 'handlebars/runtime';

slideshare_object.utils.exports(
  'templates.clipping.notice-prompt',
  Handlebars.template({
    compiler: [6, '>= 2.0.0-beta.1'],
    main: function (depth0, helpers, partials, data) {
      var stack1;

      return (
        '<div class="notice-prompt-container">\n  <div class="side-bar column small-1">\n    <div class="icon-container">\n      <div class="svg-icon" aria-hidden="true">\n' +
        '</div>\n    </div>\n  </div>\n  <div class="content-bar column small-11">\n    <div class="close-container clearfix">\n      <button class="close" aria-label="' +
        this.escapeExpression(
          this.lambda(
            (stack1 =
              (stack1 =
                (stack1 = depth0 != null ? depth0.i18n : depth0) != null
                  ? stack1.clipping
                  : stack1) != null
                ? stack1.toast
                : stack1) != null
              ? stack1.close
              : stack1,
            depth0
          )
        ) +
        '"></button>\n    </div>\n    <div class="content">\n    </div>\n  </div>\n</div>\n'
      );
    },
    usePartial: true,
    useData: true,
  })
);
